<template>
  <div class="">
    <Breadcrumb :title="$t('miga.PersonalData')" />
    <HeadingBox
      :title="$t('personaldata.title')"
      :description="$t('personaldata.description')"
    />
    <DatosIntroducidos />

    <div class="whitebox">
      <form>
        <div class="row">
          <div
            class="form-group col-lg-2 col-md-4"
            v-show="servicePoint.requiresVatID"
          >
            <label for="visitorVatIDType" class="col-12 col-form-label">

              {{ $t("tipodocumento") }} (*) </label>
            <div class="col-12">
              <select
                class="form-control form-select"
                aria-label="Tipo de documento"
                v-model="visitorVatIDType"
                id="visitor.visitorVatIDType"
                @change="onVatIDTypechange"
                tabindex="1"
              >
                <option value="1">{{ $t("nifnie") }}</option>
                <option value="2">{{ $t("pasaporte") }}</option>
              </select>
            </div>
          </div>
          <div
            class="form-group col-lg-4 col-md-8"
            v-show="servicePoint.requiresVatID"
          >
            <label for="visitorVatID" class="col-12 col-form-label"> {{ $t("nifnie") }} / {{ $t("pasaporte") }} (*)</label
            >
            <div class="col-12">
              <input
                v-model="visitor.visitorVatID"
                class="form-control"
                type="text"
                id="visitorVatID"
                @keyup="checkError"
                tabindex="2"
              />
            </div>
          </div>
          <div
            class="form-group col-lg-6"
            v-show="servicePoint.requiresVisitorName"
          >
            <label for="visitorName" class="col-12 col-form-label">{{ $t("nombre") }} (*)</label>
            <div class="col-12">
              <input
                class="form-control"
                type="text"
                id="visitorName"
                @keyup="checkError"
                v-model="visitor.visitorName"
                tabindex="3"
              />
            </div>
          </div>

          <div
            class="form-group col-lg-6"
            v-show="servicePoint.requiresVisitorName"
          >
            <label for="visitorFamilyName" class="col-12 col-form-label">{{ $t("apellido1") }} (*) </label>
            <div class="col-12">
              <input
                class="form-control"
                type="text"
                id="visitorFamilyName"
                v-model="visitor.visitorFamilyName"
                @keyup="checkError"
                tabindex="4"
              />
            </div>
          </div>
          <div
            class="form-group col-lg-6"
            v-show="servicePoint.requiresVisitorName"
          >
            <label
              for="visitorSecondFamilyName"
              class="col-12 col-form-label"
              >{{ $t("apellido2") }}</label
            >
            <div class="col-12">
              <input
                class="form-control"
                type="text"
                id="visitorSecondFamilyName"
                v-model="visitor.visitorSecondFamilyName"
                @keyup="checkError"
                tabindex="5"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <!--AA -->
          <div
            class="form-group col-lg-6"
          >
            <label for="visitorMobile" class="col-12 col-form-label">
               {{$t("telmovil")}} <span v-show="!servicePoint.requiresMobile">(*) </span>
            </label>
            <div class="col-12">
              <input
                class="form-control"
                type="tel"
                id="visitorMobile"
                v-model="telefono"
                pattern="[0-9]+"
                @keyup="checkError"
                tabindex="6"
              />
              <p class="mx-1 p-0 m-0 d-none" style="font-size: 85%" ><small>El dato es opcional. Si lo introduce podemos contactarle en caso de ser necesario.</small></p>
            </div>
          </div>

          <div
            class="form-group col-lg-6"
          >
            <label
              for="visitorEmail"
              class="col-12 col-form-label">
              {{$t("correoe")}} <span v-show="!servicePoint.requiresEmail">(*) </span>
              </label
            >
            <div class="col-12">
              <input
                class="form-control"
                type="email"
                id="visitorEmail"
                v-model="visitor.visitorEmail"
                @keyup="checkError"
                tabindex="7"
              />
              <p class="mx-1 p-0 m-0 d-none" style="font-size: 85%" v-show="!servicePoint.requiresMobile"><small>El dato es opcional. Si lo introduce podemos contactarle en caso de ser necesario.</small></p>
            </div>

          </div>

          <!--/AA -->

        </div>

        <!-- custom fields -->
        <div class="row" __v-if="false">
          <div
            class="form-group"
            :class="f.cssClass"
            v-for="(f, i) in filteredCustomFields"
            :key="i"
          >
            <label :for="i" class="col-12 col-form-label">{{ $t("custom_fields." + f._name) }} (*)</label>
            <div class="col-12">
              <input
                v-if="f.type !== 'SELECT'"
                class="form-control"
                :type="f.type"
                :id="f._name"
                v-model="visitor[i]"
                @keyup="checkError"
                @change="checkError"
              />
              <select
                :id="f._name"
                v-if="f.type === 'SELECT'"
                class="form-control form-select"
                @change="checkError"
                v-model="visitor[i]"
                :aria-label="$t('custom_fields.customField' + i)"
              >
                <option value="-"> Por favor, seleccione una opción</option>
                <option v-for="(o,opos) in f._localeValues" :key="opos" :value="o.id || o.value"> {{ o.value }}</option>
              </select>
            </div>
          </div>
        </div>
        <div
          class="form-group col-lg-12 py-2"
          v-if="servicePoint.requiresComments"
        >
          <label for="visitorEmail" class="col-12 col-form-label">{{
            $t("personaldata.motivo")
          }}</label>
          <div class="col-12">
            <textarea
              class="form-control"
              rows="3"
              id="comments"
              v-model="comments"
              @keyup="checkError"
              tabindex="7"
            />
          </div>
        </div>

        <div class="col-lg-12 pt-3">
          <div class="form-group col-12 mt-3">
            <input
              class="form-check-input mx-2"
              id="recordarme"
              type="checkbox"
              v-model="recordarme"
              tabindex="8"
            />
            <label
              class="form-check-label ml-4"
              style="display: unset"
              for="recordarme"
            >
              {{ $t("personaldata.recordarmisdatos") }}
              <p style="font-size: 70%" class="mx-4 px-3">
                {{ $t("personaldata.recordarmisdatosdesc") }}
              </p>
            </label>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="form-group col-10 mt-2">
            <input
              class="form-check-input mx-2"
              id="notificacionesPush"
              type="checkbox"
              v-model="visitor.notificacionesPush"
              v-on:change="solicitarPermisoSuscripcion()"
              tabindex="9"
              :disabled="errorActivandoNotificaciones"
            />
            <label
              class="form-check-label ml-4"
              style="display: unset"
              for="notificacionesPush"
              v-if="!errorActivandoNotificaciones"
            >
              {{ $t("personaldata.quieronotificaciones") }}
              <p style="font-size: 70%" class="mx-4 px-3">
                {{ $t("personaldata.quieronotificacionesdesc") }}
              </p>
            </label>
            <label
              v-else
              class="form-check-label ml-4"
              style="display: unset"
              for="notificacionesPush"
            >
              {{ $t("erroractivacionnotificaciones") }}
              <p style="font-size: 70%" class="mx-4 px-3">
                {{ errorActivandoNotificaciones }}
              </p>
            </label>
          </div>
        </div>
      </form>

      <AlertaError :titulo="$t('errorval')" :descripcion="errmsg" />

      <NavButton
        anterior="RGPD"
        siguiente="SelectSlot"
        :siguienteIf="!errmsg"
      />
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../components/Breadcrumb";
import DatosIntroducidos from "../components/DatosIntroducidos";
import HeadingBox from "../components/HeadingBox";
import NavButton from "../components/NavButton";
import AlertaError from "../components/AlertaError";
import Session from "@/session/Session.js";
import Utils from "@/services/Utils.js";
import APIPWA from "@/services/APIPWA.js";

export default {
  name: "PersonalData",
  components: {
    Breadcrumb,
    DatosIntroducidos,
    HeadingBox,
    AlertaError,
    NavButton,
  },
  props: {},
  computed: {
    filteredCustomFields () {
      let sp = Session.getServicePoint()
      let lang =  Session.getLanguage()
      let r = window._.filter( this.customFields, (c,k) => {
        c._name = k
        c._localeValues = c['values_' + lang.locale] || c.values_es || c.values
        window.console.log('values>', lang.locale, c._localeValues)
        return sp[k]
      })
      return r // window._.orderBy(r, 'name')
    }
  },
  data: () => ({
    soportaNotificaciones: APIPWA.supportsNotifications(),
    visitor: Session.getVisitor(),
    servicePoint: Session.getServicePoint() || {},
    errmsg: null,
    errorActivandoNotificaciones: null,
    visitorVatIDType: 1,
    telefono: null,
    comments: null,
    recordarme: false,
    customFields: Session.getConfiguration()?.custom_fields,
  }),
  mounted() {
    this.prefillForm();
    this.telefono = this.visitor.visitorMobile;
    this.checkError();
    this.checkNotifications();
  },
  beforeDestroy() {
    if (this.recordarme) this.storePersonalData();
    else this.removePersonalDataStorage();
    Session.setComments(this.comments);
  },
  methods: {
    assignCustomData() {
      window._.each( this.customFields, (f,name) => {
        this.visitor[name] = document.getElementById(name)?.value
      })
    },
    prefillForm() {
      let o = JSON.parse(
        window.localStorage.getItem("noq::personalData") || "{}"
      );
      if (o.visitorEmail || o.visitorMobile) this.recordarme = true;
      // window.console.table(o);
      this.visitor.visitorName = this.visitor.visitorName || o.visitorName;
      this.visitor.visitorFamilyName =
        this.visitor.visitorFamilyName || o.visitorFamilyName;
      this.visitor.visitorSecondFamilyName =
        this.visitor.visitorSecondFamilyName || o.visitorSecondFamilyName;
      this.visitor.visitorMobile =
        this.visitor.visitorMobile || o.visitorMobile;
      this.visitor.visitorEmail = this.visitor.visitorEmail || o.visitorEmail;
      this.visitor.visitorVatID = this.visitor.visitorVatID || o.visitorVatID;
      this.visitor.visitorVatIDType =
        this.visitor.visitorVatIDType || o.visitorVatIDType;
      this.visitorVatIDType = this.visitor.visitorVatIDType;

      this.visitor.customField1 = this.visitor.customField1 || o.customField1;
      this.visitor.customField2 = this.visitor.customField2 || o.customField2;
      this.visitor.customField3 = this.visitor.customField3 || o.customField3;

    },
    removePersonalDataStorage() {
      window.console.log("Eliminando datos personales");
      window.localStorage.removeItem("noq::personalData");
    },
    storePersonalData() {
      let o = JSON.stringify({
        visitorName: this.visitor.visitorName,
        visitorFamilyName: this.visitor.visitorFamilyName,
        visitorSecondFamilyName: this.visitor.visitorSecondFamilyName,
        visitorMobile: this.visitor.visitorMobile,
        visitorEmail: this.visitor.visitorEmail,
        visitorVatID: this.visitor.visitorVatID,
        visitorVatIDType: this.visitor.visitorVatIDType,
        customField1: this.visitor.customField1,
        customField2: this.visitor.customField2,
        customField3: this.visitor.customField3
      });
      window.localStorage.setItem("noq::personalData", o);
    },
    checkNotifications() {
      this.errorActivandoNotificaciones = null;
      window.console.log("Verificando notificaciones ..");
      if (!("Notification" in window)) {
        window.console.log("El dispositivo no soporta notificaciones.");
        this.errorActivandoNotificaciones =
          "El dispositivo no soporta notificaciones.";
      } else if (Notification.permission === "granted") {
        window.console.log("Notificaciones habilitadas");
      } else if (Notification.permission === "denied") {
        this.errorActivandoNotificaciones =
          "El dispositivo tiene las notificaciones inhabilitadas.";
        window.console.log(
          "El dispositivo tiene las notificaciones inhabilitadas."
        );
      } else {
        window.console.log("WTF", Notification.permission);
      }
    },
    async solicitarPermisoSuscripcion() {
      this.errorActivandoNotificaciones = null;
      if (!this.visitor.notificacionesPush) return;
      window.console.log("Solicitando permiso");
      try {
        let permisoNavegadorSuscripcion =
          await APIPWA.solicitarPermisosNavegador();
        window.console.log(
          "permisoNavegadorSuscripcion>",
          permisoNavegadorSuscripcion
        );
        this.visitor.notificacionesPush = true;
      } catch (err) {
        window.console.log("permiso denegado", err);
        window.console.error(err);
        this.errorActivandoNotificaciones = err;
        this.visitor.notificacionesPush = false;
      }
    },
    onVatIDTypechange(i) {
      this.visitor.visitorVatIDType = +i.srcElement.value;
      this.checkError();
    },
    normalizePhoneNr(s) {
      s = s || "";
      return s
        .replace(/["'()]/g, "")
        .replace(/\s/g, "")
        .trim();
    },
    checkError() {
      this.assignCustomData()
      if (this.servicePoint.requiresVatID) {
        if (
          !this.visitor.visitorVatID ||
          this.visitor.visitorVatID.length < 5
        ) {
          this.errmsg = this.$t("personaldata.errnonif"); // "Introduzca su NIF o NIE / pasaporte, por favor.";
          return;
        }

        if (this.visitor.visitorVatIDType === 1) {
          if (!Utils.validaNIF(this.visitor.visitorVatID)) {
            this.errmsg = this.$t("personaldata.errnif"); // "NIF/NIE incorrecto";
            return;
          }
        }
      }

      if (this.servicePoint.requiresVisitorName) {
        if (!this.visitor.visitorName) {
          this.errmsg = this.$t("personaldata.errnonombre"); // "Introduzca el motivo de su visita, por favor.";
          return;
        }

        if (!this.visitor.visitorFamilyName) {
          this.errmsg = this.$t("personaldata.errnonoprimerape"); // "Introduzca el motivo de su visita, por favor.";
          return;
        }
      }

      if (this.servicePoint.requiresMobile) {
        let m = this.normalizePhoneNr(this.telefono);
        this.visitor.visitorMobile = m;
        if (!+m || m.length < 9) {
          this.errmsg = this.$t("personaldata.errnonomovil"); // "Introduzca su numero de móvil, por favor."
          return;
        }
      }

      if (this.servicePoint.requiresEmail) {
        if (!this.visitor.visitorEmail) {
          this.errmsg = this.$t("personaldata.errnonoemail"); // "Introduzca su correo electrónico, por favor.";
          return;
        }

        if (!Utils.validaEmail(this.visitor.visitorEmail)) {
          this.errmsg = this.$t("personaldata.errnemail"); // "Correo electronico incorrecto";
          return;
        }
      }

      if (
        this.servicePoint.requiresComments &&
        (!this.comments || this.comments.length < 5)
      ) {
        this.errmsg = this.$t("personaldata.errnocomments"); // "Introduzca el motivo de su visita, por favor.";
        return;
      }

      let isMissing = f => (this.servicePoint[f] && (!this.visitor[f] || this.visitor[f] === '' || this.visitor[f] === '-')) ? f : null
      let custFieldMissing = null

      window._.each( window._.keys(this.customFields), c => custFieldMissing = custFieldMissing || isMissing(c) )
      if (custFieldMissing) {
        this.errmsg = this.$t("personaldata.errnocustomfield") + ' (' + this.$t('custom_fields.' + custFieldMissing) + ")"; // Falta un campo por introducir ..
        return;
      }

      this.errmsg = null;
      window.console.table(this.visitor)
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
<style scoped>
</style>

